<template>
  <div>
    <!-- Nothing to show here. -->
  </div>
</template>

<script>
export default {
  created () {
    this.$router.push('/dashboard')
  }
}
</script>